import { useCallback } from 'react'

import { makeStyles } from '@material-ui/core/styles'

export const useStyles = (styles, options = {}) => {
  const { theme = null } = options

  const buildStyles = useCallback(
    typeof styles === 'function'
      ? makeStyles(styles(theme))
      : makeStyles(styles),
    [],
  )

  return buildStyles()
}
